module.exports = __webpack_public_path__ + "pl.fad79a02868ced9f3a23.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pl.svg
// module chunks = styles